import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import {AuthService} from "./auth-service";

@Injectable({providedIn: "root"})
export class AuthInterceptor implements HttpInterceptor {
    private expireTimerId:any;
    private timeOutPeriod: number = 1000*60*60*24;

    constructor(private authService: AuthService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.expireTimerId) {
            clearTimeout(this.expireTimerId);
            this.expireTimerId = null;
        }

        this.expireTimerId = setTimeout(() => {
            this.authService.signOut();
        }, this.timeOutPeriod);

        return next.handle(req).pipe(tap({
            next:() => {

            },
            error: (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        console.log("!401", err);
                        clearTimeout(this.expireTimerId);
                    }
                    else{
                        console.log("401 - Not authenticated", err);
                        const reason = err.error;

                        if (reason === 'SessionExpired') {
                            const currentPath = window.location.pathname + window.location.search;
                            window.location.href = `/login?url=${encodeURIComponent(currentPath)}`;
                        }
                    }
                }
            }}));
    }
}
